<section tuiContent>
	@if (form) {
		<form [formGroup]="form" (ngSubmit)="onSubmit()">
			<label tuiLabel>
				{{ 'data.email' | transloco }}*

				<tui-textfield tuiTextfieldSize="m">
					<input
						formControlName="email"
						tuiInput
						autocomplete="email"
					/>
				</tui-textfield>

				<tui-error formControlName="email" />
			</label>

			<label tuiLabel>
				{{ 'data.name' | transloco }}

				<tui-textfield tuiTextfieldSize="m">
					<input
						formControlName="name"
						tuiInput
						autocomplete="name"
					/>
				</tui-textfield>

				<tui-error formControlName="name" [order]="['required']" />
			</label>

			<label tuiLabel>
				{{ 'data.phone' | transloco }}

				<!-- TODO: (Taiga UI migration) tui-input-phone migration (see https://taiga-ui.dev/components/input-phone):
     - countrycode, phonemaskaftercountrycode have no direct v5 equivalent.
       In v5 both are replaced by a single [mask] input of type MaskitoOptions.
       Replace with: <input tuiInputPhone [mask]="phoneOptions" /> where
       phoneOptions = maskitoPhoneOptionsGenerator({countryIsoCode: 'RU', metadata}) from @maskito/phone. -->
				<tui-textfield tuiTextfieldSize="m">
					<input
						tuiInputPhone
						formControlName="tel"
						autocomplete="tel"
					/>
				</tui-textfield>

				<tui-error formControlName="tel" [order]="['required']" />
			</label>

			<label tuiLabel>
				{{ 'data.message' | transloco }}

				<tui-textfield tuiTextfieldSize="m">
					<textarea
						tuiTextarea
						formControlName="message"
						[limit]="maxLength"
					></textarea>
				</tui-textfield>
			</label>
		</form>
	}
</section>

<footer tuiFooter>
	<button
		tuiButton
		appearance="accent"
		[loading]="busy()"
		(click)="onSubmit()"
	>
		{{ 'action.send' | transloco }}
	</button>
</footer>
